import { render, staticRenderFns } from "./SonAboutUs.vue?vue&type=template&id=48e87130&scoped=true&"
import script from "./SonAboutUs.js?vue&type=script&lang=js&"
export * from "./SonAboutUs.js?vue&type=script&lang=js&"
import style0 from "./SonAboutUs.vue?vue&type=style&index=0&id=48e87130&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e87130",
  null
  
)

export default component.exports